import { transformPeriod } from '@core/mappers/offer/transformPeriod';
import { MetaDataDto } from '@core/mappers/offer/dtos/MetaDataDto';
import {
    MetaData,
    BookingStatus,
    Time,
} from '@core/models/offer/MetaData';

export function transformMetaData(dto: MetaDataDto): MetaData {
    const metaData: MetaData = {
        team1Score: dto.homeTeamScore ? parseInt(dto.homeTeamScore, 10) : undefined,
        team2Score: dto.awayTeamScore ? parseInt(dto.awayTeamScore, 10) : undefined,
        minute: dto.minutes,
        periodStatus: dto.periodStatus || '',
        matchStatusLabel: dto.matchStatusLabel,
        periods: dto.periods ? dto.periods.map(transformPeriod).sort((period) => period.number) : [],
        bookingStatus: (dto.bookingStatus as BookingStatus) || undefined,
        team1GemScore: dto.homeTeamGameScore,
        team2GemScore: dto.awayTeamGameScore,
        serve: dto.teamServing,
        status: dto.status,
    };

    if (dto.stoppageTime) {
        const stoppageTime = parseTimeString(dto.stoppageTime).minutes;
        // Stoppage time is coming from our feed provider in the following
        // format: "2:22" which means 2 minutes and 22 seconds. We show
        // only the minutes, which means we have to show 3' instead of 2'
        metaData.stoppageTime = stoppageTime + 1;
    }
    metaData.t1YCrd = dto.homeTeamYellowCards;
    metaData.t2YCrd = dto.awayTeamYellowCards;
    metaData.t1RCrd = dto.homeTeamRedCards;
    metaData.t2RCrd = dto.awayTeamRedCards;
    metaData.t1Crn = dto.homeTeamCorners;
    metaData.t2Crn = dto.awayTeamCorners;

    return metaData;
}

function parseTimeString(time: string): Time {
    const [minutes, seconds] = time.split(':').map((x) => parseInt(x, 10));
    return {
        minutes,
        seconds,
    };
}
